/**
 * AST 기반 자동 생성된 검증 함수
 * 이 파일은 scripts/generate-validators.ts에 의해 자동 생성됩니다.
 * 수동으로 수정하지 마세요.
 * 
 * 생성 시간: 2026-09-18T08:13:01.384Z
 * 소스 파일: src/data/dto/admin/doctor-create-reponse-dto
 */

import type { DoctorCreateResponseDto } from "@/data/dto/admin/doctor-create-reponse-dto";

/**
 * DoctorCreateResponseDto 타입 가드 함수
 * AST 분석을 통해 자동 생성된 최적화된 검증 함수
 */
export function isDoctorCreateResponseDto(input: unknown): input is DoctorCreateResponseDto {
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    return false;
  }
  
  const obj = input as Record<string, unknown>;
  
  return (
    typeof obj.doctorUuid === "string"
  );
}

/**
 * DoctorCreateResponseDto 상세 검증 결과 반환 함수
 * 검증 실패 시 상세한 에러 정보를 반환합니다.
 */
export interface IValidation<T> {
  success: boolean;
  data?: T;
  errors?: Array<{ path: string; expected: string; value: unknown }>;
}

export function validateDoctorCreateResponseDto(input: unknown): IValidation<DoctorCreateResponseDto> {
  const errors: Array<{ path: string; expected: string; value: unknown }> = [];
  
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    errors.push({
      path: "",
      expected: "object",
      value: input,
    });
    return {
      success: false,
      errors,
    };
  }
  
  const obj = input as Record<string, unknown>;
  
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      errors.push({ path: "", expected: "object", value: obj });
    } else {
      const objObj = obj as Record<string, unknown>;
      // doctorUuid (required)
      if (objObj.doctorUuid === undefined) {
        errors.push({ path: "doctorUuid", expected: "string", value: undefined });
      } else {
        if (typeof objObj.doctorUuid !== "string") {
          errors.push({ path: "doctorUuid", expected: "string", value: objObj.doctorUuid });
        }
      }
    }
  
  if (errors.length === 0 && isDoctorCreateResponseDto(input)) {
    return {
      success: true,
      data: input,
    };
  }
  
  return {
    success: false,
    errors: errors.length > 0 ? errors : [
      {
        path: "",
        expected: "DoctorCreateResponseDto",
        value: input,
      },
    ],
  };
}

/**
 * DoctorCreateResponseDto 검증 후 에러 throw 함수
 * 검증 실패 시 상세한 에러 정보를 포함하여 에러를 throw합니다.
 */
export function assertDoctorCreateResponseDto(input: unknown): DoctorCreateResponseDto {
  const validation = validateDoctorCreateResponseDto(input);
  if (!validation.success) {
    const errorDetails = validation.errors?.map(err => 
      `  - ${err.path}: 예상 타입 ${err.expected}, 실제 값: ${JSON.stringify(err.value)}`
    ).join("\n") || "알 수 없는 오류";
    throw new Error(`[assertDoctorCreateResponseDto] :: 검증 실패: DoctorCreateResponseDto 타입과 일치하지 않습니다\n\n오류 상세:\n${errorDetails}`);
  }
  return validation.data!;
}
